import { defineStore } from "pinia";
import { useUserStore } from "@/stores/user";
import enterChangeDialog from "@/components/EnterChangeDialog/index";

interface RunTimeConfigPublic {
    userNodeEnv: string;
    publicPath: string;
    apiUrl: string;
    baseFileUrl: string;
    chatAiUrl: string;
    originUrl: string;
    wsUrl: string;
    tenantId: string;
    wxAppId: string;
}

let connected = false;
let failure = false;

export const useRuntimeConfig = defineStore("runtimeConfig", {
    state: (): {
        public: RunTimeConfigPublic;
    } => ({
        public: {
            userNodeEnv: import.meta.env.VITE_USER_NODE_ENV || "",
            publicPath: import.meta.env.VITE_PUBLIC_PATH || "",
            apiUrl: import.meta.env.VITE_API_URL || "",
            baseFileUrl: import.meta.env.VITE_BASE_FILE_URL || "",
            chatAiUrl: import.meta.env.VITE_AI_URL || "",
            originUrl: import.meta.env.VITE_ORIGIN_URL || "",
            wsUrl: import.meta.env.VITE_WS_URL || "",
            tenantId: import.meta.env.VITE_TENANT_ID || "",
            wxAppId: import.meta.env.VITE_WX_APP_ID || ""
        }
    }),
    actions: {
        connectWebsocket() {
            if (connected || failure) return;
            connected = true;
            let WS: WebSocket;

            const user = useUserStore();
            const auth = `authorization=${user.token}`;
            console.log("WS地址---", `${import.meta.env.VITE_WS_URL}?${auth}`);

            try {
                WS = new WebSocket(`${import.meta.env.VITE_WS_URL}?${auth}`);

                WS.onopen = function () {
                    console.log("建立WS成功---", WS.readyState);
                };
                WS.onmessage = async function (res) {
                    const data = JSON.parse(res.data);
                    const type = data?.type;
                    console.log(type, "----------type-------------");

                    switch (type) {
                        // 用户状态刷新
                        case 1:
                            const { getUserInfo } = await import("@/utils/common");
                            await getUserInfo();
                            break;
                        case 4:
                            // 客户企业主体发生变更
                            console.log(type, "客户企业主体发生变更");
                            await enterChangeDialog();
                            break;
                    }
                };
                WS.onclose = function (event: object) {
                    console.log("WS关闭链接---", event);
                    connected = false;
                };
                WS.onerror = function (err: object) {
                    failure = true;
                    console.log(err);
                };

                // 每25秒发送一个心跳信息
                const loopConnection = () => {
                    setInterval(() => {
                        if (WS.readyState === 1) {
                            WS.send(JSON.stringify({ heartBeat: "HEARTBEAT" }));
                        } else {
                            connected = false;
                        }
                    }, 25000);
                };
                loopConnection();
            } catch (err) {
                failure = true;
                console.error(err);
            }
        }
    },
    persist: true
});
